import { render, staticRenderFns } from "./EditarNomeAdministrador.vue?vue&type=template&id=22735abf"
import script from "./EditarNomeAdministrador.vue?vue&type=script&lang=js"
export * from "./EditarNomeAdministrador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports